import * as React from 'react';
import { Button } from 'react-bootstrap';
import { withFormik, FormikProps, Form, Field } from 'formik';
import * as Yup from 'yup';
import { translateService } from '../../services/TranslateService';
import './LoginForm.scss';

interface LoginFormProps {
  onNumberSubmit: (e: LoginFormValues) => void;
  onPINSubmit: (e: LoginFormValues) => void;
  phoneNumber?: string;
  // onLogin: (e: LoginFormValues) => void;
}

interface LoginFormValues {
  phoneNumber: string;
  pin: string;
}

interface OtherProps {
  step: number;
}

// Aside: You may see InjectedFormikProps<OtherProps, FormValues> instead of what comes below in older code.. InjectedFormikProps was artifact of when Formik only exported a HoC. It is also less flexible as it MUST wrap all props (it passes them through).
const InnerForm = (props: OtherProps & FormikProps<LoginFormValues>) => {
  const pinRef = React.useRef<HTMLInputElement>(null);
  let disabled = false;
  if (props.step === 0 && (props.values.phoneNumber === '' || props.errors.phoneNumber)) {
    disabled = true;
  }

  if (props.step === 1 && (props.values.pin === '' || props.errors.pin)) {
    disabled = true;
  }

  React.useEffect(
    () => {
      props.step > 0 && pinRef.current && pinRef.current.click();
    },
    [props.step]
  );

  return (
    <Form className='login-form'>
      <Field
        type='tel'
        name='phoneNumber'
        disabled={props.step === 1}
        placeholder={translateService.translate('loginScreen.phoneNumber')}
        className='form-control login-form__inputs'
      />

      <Field
        type={props.step === 0 ? 'hidden' : 'tel'}
        name='pin'
        innerRef={pinRef}
        onClick={() => pinRef.current && pinRef.current.focus()}
        disabled={props.step === 0}
        placeholder={translateService.translate('loginScreen.pin')}
        className='form-control login-form__inputs'
      />

      <Button type='submit' disabled={disabled} color='primary' className='btn btn-primary btn-block btn-cta'>
        {translateService.translate('loginScreen.submit')}
      </Button>

      <div className='error-text'>
        {props.errors.phoneNumber || props.errors.pin ? (
          <p className='mb-0 mt-3'>{props.errors.phoneNumber || props.errors.pin}</p>
        ) : undefined}
      </div>
    </Form>
  );
};

// Wrap our form with the using withFormik HoC
export const LoginForm = withFormik<OtherProps & LoginFormProps, LoginFormValues>({
  // Transform outer props into form values
  mapPropsToValues: (props: any) => {
    return {
      phoneNumber: props.phoneNumber ? props.phoneNumber : '',
      pin: '',
    };
  },

  validationSchema: (props: any) =>
    Yup.object().shape({
      phoneNumber: Yup.string()
        .matches(/^\+?\d+$/, translateService.translate('loginScreen.patternError'))
        .min(5, translateService.translate('loginScreen.minError'))
        .max(20, translateService.translate('loginScreen.maxError'))
        .required(translateService.translate('loginScreen.reqError')),
      pin: Yup.string().matches(/^\d{4}$/, translateService.translate('loginScreen.pinPatternError')),
    }),

  handleSubmit: (values, { props }) => {
    if (props.step === 0) {
      props.onNumberSubmit(values);
    } else {
      props.onPINSubmit(values);
    }
  },
})(InnerForm);
